import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { WebEditPageShell } from '../../../components/cv/WebEditPageShell';
import { EditEducationForm } from '../../../components/cv/forms/EditEducationForm';
import { useCVData } from '../../../lib/cv-mock-data';
import { useUpsertEducation, useDeleteEducation } from '../../../hooks/useProfileApi';
import { mapEducationToAPI } from '../../../lib/cv-mapping';
import { assertCvItemBatchSaved } from '../../../lib/cv-write-coordinator';

export default function EditEducationWebScreen() {
  const { t } = useTranslation('seeker');
  const { profile, profileRef } = useCVData();
  const upsertEdu = useUpsertEducation();
  const deleteEdu = useDeleteEducation();
  const initialIdsRef = useRef(new Set(profile.education.map((e) => e.id)));

  const handleSave = async () => {
    const items = profileRef.current.education;
    const currentIds = new Set(items.map((e) => e.id));
    const removedIds = [...initialIdsRef.current].filter((id) => !currentIds.has(id));
    const results = await Promise.allSettled([
      ...items.map((edu, i) => upsertEdu.mutateAsync(mapEducationToAPI(edu, i))),
      ...removedIds.map((id) => deleteEdu.mutateAsync(id)),
    ]);
    // One save, one answer: a CV conflict choice (B02) is reported as such;
    // otherwise only a save where every item failed is a failure.
    assertCvItemBatchSaved(results);
  };

  return (
    <WebEditPageShell title={t('cv.edit.education')}>
      <EditEducationForm onSave={handleSave} />
    </WebEditPageShell>
  );
}
